/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_BlockedInputs */



/**
* | output |
* | --- |
* | "Blocked — allow notifications in your browser settings" |
*
* @param {Notifications_BlockedInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const notifications_blocked = /** @type {((inputs?: Notifications_BlockedInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_BlockedInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Bloquées — autorisez les notifications dans les paramètres de votre navigateur")
	if (locale === "es") return /** @type {LocalizedString} */ ("Bloqueadas — permita las notificaciones en los ajustes de su navegador")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Bloqueadas — permita as notificações nas configurações do seu navegador")
	if (locale === "it") return /** @type {LocalizedString} */ ("Bloccate — consenti le notifiche nelle impostazioni del browser")
	return /** @type {LocalizedString} */ ("Blocked — allow notifications in your browser settings")
});